export const audioBlockTypes = {
  defaultCrossPromo: "default-cross-promo",
  defaultAd: "default-redcircle-ad",
  custom: "custom",
};
